import React from 'react'
import styled from 'styled-components'

const T = styled.table`
  width: 100%;

  & tbody tr:nth-of-type(odd) {
    background-color: #f0f0f0;
  }

  & th {
    padding: 11px 27px 10px;
    font-size: 14px;
    color: #939393;
    text-align: left;
    border: 0;    
  }
  
  & td {
    font-size: 14px;
    padding: 12px 21px;
    color: blue;
    border: 0;
    border-left: 1px solid rgb(235, 235, 235);
  }
  
  & td:first-child {
    border-left: 0;
  }
`

const Table = ({ children }) => (
  <T>
    {children}
  </T>
)

export default Table



// WEBPACK FOOTER //
// ./src/basic/Table.js